import React from 'react'
import { ReactJsonViewProps } from '@microlink/react-json-view'
import loadable from '@loadable/component'
const ReactJson = loadable(() => import('@microlink/react-json-view'))

export const DebugJsonView = (props: ReactJsonViewProps) => {
  if (typeof document === 'undefined') {
    return <></>
  }

  return <ReactJson {...props} />
}
